import { Component, computed, inject, signal } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { CookiePreferencesComponent } from '../cookie-preferences/cookie-preferences.component';
import { ResponsiveDialogService } from '../../../shared/services/responsive-dialog.service';
import { AppInsightsService } from '../../../exception-handling/app-insights.service ';

@Component({
    selector: 'app-cookie-banner',
    imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
],
    templateUrl: './cookie-banner.component.html',
    styleUrl: './cookie-banner.component.scss'
})
export class CookieBannerComponent {  
  private readonly responsiveDialogService = inject(ResponsiveDialogService);
  private readonly cookieService = inject(CookieConsentService);
  private readonly logService = inject(AppInsightsService);
  
  // Reactive state
  protected showBanner = computed(() => this.cookieService.showBanner());
  protected isLoading = signal(false);

  constructor() {}
  /**
   * Accept essential cookies and close banner
   */
  acceptCookies(): void {
    this.isLoading.set(true);
    
    try {
      const preferences = {
        essential: true,
        analytics: false,
        marketing: false
      };

      this.cookieService.saveConsentToLocalStorage(preferences);
    } catch (error) {
      this.logService.logError(error, 'Error accepting cookies:');
      // Still hide banner to prevent infinite loop
      this.cookieService.hideBanner();
    } finally {
      this.isLoading.set(false);
    }
  }

  /**
   * Open preferences modal
   */
  openPreferences(): void {
    const dialogRef = this.responsiveDialogService.open(CookiePreferencesComponent, {
      desktopWidth: '500px',
      mobileFullscreen: false,
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: false,
      panelClass: 'cookie-preferences-dialog'
    });

    dialogRef.afterClosed().subscribe((preferences) => {
      if (preferences) {
        this.savePreferences(preferences);
      }
    });
  }

  /**
   * Save preferences from modal
   */
  private savePreferences(preferences: any): void {
    this.isLoading.set(true);
    
    try {
      this.cookieService.saveConsentToLocalStorage(preferences);
    } catch (error) {
      this.logService.logError(error, 'Error saving preferences:');
      this.cookieService.hideBanner();
    } finally {
      this.isLoading.set(false);
    }
  }
}
